// URL utilities

/**
 * Ensures a URL has an explicit protocol.
 * - Leaves absolute http(s) URLs unchanged
 * - Converts protocol-relative URLs (//example.com/...) to https
 * - Leaves relative paths (starting with /) unchanged
 * - For any other bare domain/path, prefixes with https://
 */
;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:tillamook-com":true});}catch(e){}}();export const addProtocol = (rawUrl = '') => {
    const url = typeof rawUrl === 'string' ? rawUrl.trim() : '';
    if (!url) return '';

    // Preserve special schemes
    if (url.startsWith('data:') || url.startsWith('blob:')) return url;

    // Absolute URLs
    if (url.startsWith('http://') || url.startsWith('https://')) return url;

    // Protocol-relative must be handled BEFORE single-slash relative
    if (url.startsWith('//')) return `https:${url}`;

    // Same-origin relative path
    if (url.startsWith('/')) return url;

    return `https://${url}`;
};
